export { default as Column } from './Column';
export { default as Row } from './Row';



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/Alignment/GridPositions/index.ts